import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/zxfw/banner.png';
const _hoisted_1 = {
  class: "zxfw-page"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  class: "service-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "policy-cards"
};
const _hoisted_7 = {
  class: "card-title"
};
const _hoisted_8 = {
  class: "card-content"
};
const _hoisted_9 = {
  class: "section"
};
const _hoisted_10 = {
  class: "institutions-section"
};
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = {
  class: "institution-name"
};
import { ref, onMounted } from 'vue';
import { getConsultationServiceInfo } from '@/api/consultation';
export default /*@__PURE__*/_defineComponent({
  __name: 'Zxfw',
  setup(__props) {
    const institutionNames = ['工商财税', '律师事务所', '审计事务所', '知识产权机构'];
    // 咨询服务信息数据
    const serviceInfo = ref({});
    // 获取咨询服务信息
    const fetchServiceInfo = async () => {
      try {
        const res = await getConsultationServiceInfo();
        if (res.code === 200) {
          serviceInfo.value = res.data;
          // console.log('咨询服务信息:', serviceInfo.value);
        }
      } catch (error) {
        console.error('获取咨询服务信息失败:', error);
      }
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchServiceInfo();
    });
    return (_ctx, _cache) => {
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "咨询服务",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SectionTitle, {
        title: "咨询服务",
        "show-more": false
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(serviceInfo.value.descInfo?.description || '我们为转制企业不同成长阶段，为企业提供创业辅导、技术转化、知识产权申报、商业策划咨询服务，陪伴企业稳越不确定性，赋能企业快速成长'), 1)])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "咨询政策",
        "show-more": false
      }), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceInfo.value.consultationPolicy, policy => {
        return _openBlock(), _createElementBlock("div", {
          class: "policy-card",
          key: policy.id
        }, [_createElementVNode("div", _hoisted_7, _toDisplayString(policy.label), 1), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(policy.description.split('\n\n'), (line, index) => {
          return _openBlock(), _createElementBlock("p", {
            key: index
          }, _toDisplayString(line), 1);
        }), 128))])]);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_SectionTitle, {
        title: "服务机构",
        "show-more": false
      }), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceInfo.value.environmentOrganization, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "institution-item",
          key: item.id
        }, [_createElementVNode("img", {
          src: item.url,
          alt: item.label
        }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, _toDisplayString(item.label), 1)]);
      }), 128))])])]), _createVNode(_component_Footer)]);
    };
  }
});